import React from "react";
import PropTypes from "prop-types";

import { LazyLoadDropdown } from "@sportal/cdk/dropdown/LazyLoadDropdown";
import { UnstyledButton } from "@sportal/cdk/unstyledButton/UnstyledButton";
import { useIntlTranslate } from "../../hooks";
import { Icon } from "../icon/Icon";

import "./DeviceDropdownMenu.scss";

export const DeviceDropdownMenu = ({ menuItems, deviceName }) => {
  const translate = useIntlTranslate();

  const label = deviceName
    ? translate("aria_named_device_actions", {
        deviceName,
      })
    : translate("aria_device_actions");

  return (
    <LazyLoadDropdown
      className={"device-menu"}
      items={menuItems}
      toggleButton={
        <UnstyledButton className="device-menu__toggle-button">
          <Icon icon="fa-solid fa-ellipsis-v" />
        </UnstyledButton>
      }
      hiddenLabel={label}
    />
  );
};

DeviceDropdownMenu.propTypes = {
  menuItems: PropTypes.array.isRequired,
  deviceName: PropTypes.string,
};
